import { ReactNode } from 'react';
import { theme } from '@frontend/theme';
import { Text } from '../../../text';

type AiActivityBubbleProps = {
  text: ReactNode;
  leadingIcon?: ReactNode;
};
export const AiActivityBubble = ({ text, leadingIcon }: AiActivityBubbleProps) => {
  return (
    <div
      className='bubble-content'
      css={{
        display: 'flex',
        alignItems: 'center',
        columnGap: theme.spacing(1),
      }}
    >
      {leadingIcon}
      <Text size='large' css={{ wordBreak: 'break-word' }} className='bubble-text' color='default'>
        {text}
      </Text>
    </div>
  );
};
